/**
 * Role Feature Matrix
 * 
 * Maps each role to its features.
 * Features are inherited: BASIC → PREMIUM → PRO1 → PRO2
 * 
 * @module roleMatrix
 */

import { ROLES } from './roleConstants';
import { FEATURES } from './featurePermissions';

/**
 * Role Feature Matrix
 * 
 * Each role lists only NEW features (inheritance handled in controller).
 * - BASIC: Free tier features
 * - PREMIUM: Premium tier features (automatically includes BASIC)
 * - PRO1: Elite tier features (automatically includes BASIC + PREMIUM)
 * - PRO2: PRO2 tier features (automatically includes BASIC + PREMIUM + PRO1)
 */
export const ROLE_FEATURES = {
  [ROLES.BASIC]: [
    // Free tier features
    FEATURES.MP_CHART_INDEX,
    FEATURES.OPTIONS_TABLE,
    FEATURES.GREEKS_TABLE,
    FEATURES.INDEX_TABLE,
    FEATURES.POSITION_TABLE,
    FEATURES.FII_DATA,
    FEATURES.IV_CURVES,
    FEATURES.OI_BAR_CHARTS,
    FEATURES.PAYOFF_CHARTS,
    FEATURES.HV_CHARTS,
  ],
  
  [ROLES.PREMIUM]: [
    // Premium tier features (BASIC features inherited automatically)
    FEATURES.SPECTRUM_CHARTS,
    FEATURES.NTM_VOLX_CHARTS,
    FEATURES.NTM_OI_CHANGE,
    FEATURES.GAMMA_CASH_BARS,
    FEATURES.MP_BOOKMARKS,
    FEATURES.MP_CUSTOM_KRLS,
    FEATURES.HISTORICAL_COMPARISON,
    FEATURES.MULTI_WINDOW,
    FEATURES.MP_ADVANCED_TOOLS,
    FEATURES.SNAKES_CHARTS,
    FEATURES.LINE_CHART_BASIC,
    FEATURES.DATE_PICKER,
    FEATURES.DRAWING_TOOL,
    FEATURES.MP_CHART_STOCKS, // requires mp_stocks resource
    FEATURES.PREVIEW_BUTTON,
  ],
  
  [ROLES.PRO1]: [
    // Elite tier features (BASIC + PREMIUM features inherited automatically)
    FEATURES.OF_CHART_INDEX,
    FEATURES.OF_CHART_STOCKS,
    FEATURES.BALANCE_IMBALANCE,
    FEATURES.LINE_CHART_ELITE,
    FEATURES.IV_RANGE_CHART,
    FEATURES.GAMMA_DENSITY,
    FEATURES.GAMMA_CURVES,
    FEATURES.GLOBAL_BOOKMARKS,
  ],
  
  [ROLES.PRO2]: [
    // PRO2 inherits all PRO1 features (BASIC + PREMIUM + PRO1)
    FEATURES.BROKER_LOGIN,
  ]
};

